/**
 * Directive: inputFieldWithLabel
 */
import { MaskDirectiveModule } from '@b2b/common/directives/mask/mask.directive';
import { input } from '@b2b/types/core';
import angular from 'angular';

InputFieldWithLabelDirective.$inject = [];

function InputFieldWithLabelDirective() {
  InputFieldWithLabelController.$inject = ['$scope'];

  function InputFieldWithLabelController($scope) {
    var ctrl = {
      setFieldFocus: $scope.setFieldFocus,
      groupTypeClass: $scope.isPanelGroup ? 'panel-form-group' : 'form-group',
      fieldFocusTimeout: $scope.fieldFocusTimeout ? $scope.fieldFocusTimeout : 0,

      label: $scope.label || '',
      info: false,
      error: false,

      maskValue: input<{ unmasked: string; masked: string }>(),

      init: function () {
        $scope.$on(
          'destroy',
          $scope.$watch('errors', function () {
            if ($scope.errors && $scope.errors[$scope.fieldName]) {
              ctrl.error = $scope.errors[$scope.fieldName].message;
            } else {
              ctrl.error = false;
            }
          })
        );

        $scope.$on(
          'destroy',
          $scope.$watch('info', function () {
            if ($scope.info) {
              ctrl.info = $scope.info;
            } else {
              ctrl.info = false;
            }
          })
        );
      },

      checkValid: function () {
        var r = true;

        if ($scope.errorMessage) {
          r = $scope.validTest !== undefined ? $scope.validTest : true;
        } else {
          r = !ctrl.error;
        }
        return r;
      },

      notifyOnChange: function () {
        return !($scope.notifyOnBlur && ($scope.notifyOnBlur === true || $scope.notifyOnBlur === 'true'));
      },

      onChanged: function () {
        if ($scope.uppercase) {
          $scope.model = ($scope.model || '').toUpperCase();
        }

        if (ctrl.notifyOnChange() && typeof $scope.modelChanged === 'function') {
          $scope.modelChanged();
        }
      },

      onBlur: function () {
        if (typeof $scope.modelChanged === 'function') {
          $scope.modelChanged();
        }

        if (typeof $scope.onBlur === 'function') {
          $scope.onBlur();
        }
      },
    };

    $scope.inputFieldWithLabel = ctrl;
    ctrl.init();
  }

  function InputFieldWithLabelControllerLink($scope, $element, $attrs) {}

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/inputFieldWithLabel/inputFieldWithLabel.tpl.html',
    scope: {
      type: '@',
      name: '@',
      label: '@',
      icon: '@',
      useFullWidth: '@', // Used in conjunction with maxlength to prevent constrained width
      model: '=',
      modelChanged: '&',
      onBlur: '&',
      notifyOnBlur: '@',
      disabled: '=',
      useCancel: '@',
      setFieldFocus: '@setfieldfocus',
      fieldFocusTimeout: '@',
      maxLength: '@maxlength',
      hideLabel: '@hidelabel',
      validTest: '=validtest',
      errorMessage: '=errormessage',
      numericOnly: '@',
      errors: '=',
      info: '=',
      fieldName: '@',
      required: '@',
      uppercase: '<',
      maskOptions: '<',
      maskValue: '<',
    },
    link: InputFieldWithLabelControllerLink,
    controller: InputFieldWithLabelController,
  };
}

export const InputFieldWithLabelModule = angular
  .module('acme.common.directive.inputFieldWithLabel', [
    'acme.common.directive.inputFieldError',
    'acme.common.directive.numeric',
    'acme.common.directive.fieldFocus',
    MaskDirectiveModule,
  ])
  .directive('inputFieldWithLabel', InputFieldWithLabelDirective).name;
